"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicOptionsInput = void 0;
const React = require("react");
const standardizeOptions_1 = require("../../../../helpers/standardizeOptions");
const SingleOptionsInput_1 = require("../SingleOptionsInput");
const MultiOptionsInput_1 = require("../MultiOptionsInput");
const ButtonOptionsInput_1 = require("../ButtonOptionsInput");
const DynamicOptionsInput = ({ options, value, allowMultiple, onInputChange, placeholderValue, disabled, autoOrder }) => {
    const stdOptions = (0, standardizeOptions_1.standardizeOptions)(options, autoOrder);
    if (stdOptions.length < 3) {
        return (React.createElement("span", { "data-test": "buttonOptionsInput", "data-dynamic-input": "ButtonOptionsInput" },
            React.createElement(ButtonOptionsInput_1.ButtonOptionsInput, { options: options, value: value, allowMultiple: allowMultiple, onInputChange: onInputChange, disabled: disabled })));
    }
    else if (allowMultiple) {
        return (React.createElement("span", { "data-test": "multiOptionsInput", "data-dynamic-input": "MultiOptionsInput" },
            React.createElement(MultiOptionsInput_1.MultiOptionsInput, { options: options, value: value, onInputChange: onInputChange, disabled: disabled })));
    }
    else {
        return (React.createElement("span", { "data-test": "singleOptionsInput", "data-dynamic-input": "SingleOptionsInput" },
            React.createElement(SingleOptionsInput_1.SingleOptionsInput, { options: options, value: value, onInputChange: onInputChange, placeholder: placeholderValue, disabled: disabled })));
    }
};
exports.DynamicOptionsInput = DynamicOptionsInput;
//# sourceMappingURL=index.js.map